import React from 'react'
import PropTypes from 'prop-types'

const DeleteIcon = ({ style, className, width = 20, height = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    width={width}
    height={height}
    viewBox="0 0 20 20"
  >
    <g fill="#FF2D4F" fillRule="evenodd">
      <rect width="20" height="20" fillOpacity=".15" rx="2" />
      <path d="M8.788 10L5.15 6.363l1.212-1.212L10 8.788l3.637-3.637 1.212 1.212L11.212 10l3.637 3.637-1.212 1.212L10 11.212 6.363 14.85l-1.212-1.212L8.788 10z" />
    </g>
  </svg>
)

DeleteIcon.propTypes = {
  style: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
}

export default DeleteIcon
